import { render, staticRenderFns } from "./MobileIcon.vue?vue&type=template&id=45ed50f2&scoped=true"
import script from "./MobileIcon.vue?vue&type=script&lang=js"
export * from "./MobileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed50f2",
  null
  
)

export default component.exports